module.exports = __webpack_public_path__ + "img/13.1a4776d1.png";